module.exports = __webpack_public_path__ + "static/img/bystage_white_04.9afafa8c.svg";